import { render, staticRenderFns } from "./EventSettings.vue?vue&type=template&id=31c32cf4&scoped=true"
import script from "./EventSettings.vue?vue&type=script&lang=ts"
export * from "./EventSettings.vue?vue&type=script&lang=ts"
import style0 from "./EventSettings.vue?vue&type=style&index=0&id=31c32cf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c32cf4",
  null
  
)

export default component.exports